import multiguard from 'vue-router-multiguard'

import Admin from '@/components/admin/Index'
import SetupAccounts from '@/components/admin/AdminSetupAccountsDialog'
import Audiences from '@/components/audiences/Index'
import Auth from '@/components/auth/Index'
import Events from '@/components/campaigns/events/Index'
import Campaign from '@/components/campaigns/Index'
import Campaigns from '@/components/campaigns/overview/Index'
import Fundraising from '@/components/campaigns/fundraising/Index'
import VolunteerOutreach from '@/components/campaigns/volunteer-outreach/Index'
import VoterOutreach from '@/components/campaigns/voter-outreach/Index'
import Channels from '@/components/channels/Index'
import Creative from '@/components/creative/Index'
import Dashboard from '@/components/Dashboard'
import ErrorsHandling from '@/components/errors/TheErrorsHandling'
import Goals from '@/components/goals/Index'
import LandingPages from '@/components/landing-pages/Index'
import MobilizeAdHelpers from '@/components/mobilize/ad-helpers/Index'
import MobilizeLiveEvents from '@/components/mobilize/local-events/Index'
import MobilizeCompetitiveReport from '@/components/mobilize/reports/Competitive'
import MobilizeV2Dashboard from '@/components/mobilizev2/Index'
import MobilizeV2CampaignList from '@/components/mobilizev2/campaigns/Index'
import MobilizeV2CreateCampaign from '@/components/mobilizev2/campaigns/Create'
import MobilizeV2CampaignDetail from '@/components/mobilizev2/campaigns/Detail'
import MobilizeV2EventList from '@/components/mobilizev2/events/Index'
import MobilizeV2EventDetail from '@/components/mobilizev2/events/Detail'
import MobilizeV2CreateTemplates from '@/components/mobilizev2/create-templates/Index'
import MobilizeV2ImageTemplateList from '@/components/mobilizev2/image-templates/Index'
import MobilizeV2CreateImageTemplate from '@/components/mobilizev2/image-templates/Create'
import MobilizeV2ImageTemplateDetail from '@/components/mobilizev2/image-templates/Detail'
import Mobilizev2PreviewAds from '@/components/mobilizev2/preview-ads/Index'
import MobilizeV2TextTemplateList from '@/components/mobilizev2/text-templates/Index'
import MobilizeV2CreateTextTemplate from '@/components/mobilizev2/text-templates/Create'
import MobilizeV2TextTemplateDetail from '@/components/mobilizev2/text-templates/Detail'
import NewAds from '@/components/new-ads/Index'
import NewAdvertiser from '@/components/new-advertiser/Index'
import NonProfitHome from '@/components/NonProfitHome'
import Preview from '@/components/preview/Index'
import PreviewShow from '@/components/preview/show-preview/Index'
import Reporting from '@/components/reporting/ReportingComponent'
import SetupChecklist from '@/components/setup-checklist/Index'
import SetupChecklistPreview from '@/components/setup-checklist/preview/Index'
import Welcome from '@/components/welcome/Index'

import guards from './guards'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: 'campaigns/new'
  },
  {
    path: '/n',
    name: 'NonProfitHome',
    component: NonProfitHome,
    props: { model: 'tab-0' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/login',
    name: 'Login',
    component: Auth,
    props: { page: 'login' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Auth,
    props: { page: 'signup' },
    beforeEnter: multiguard([guards.redirectToHome])
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    beforeEnter: multiguard([guards.checkAuthWithoutSelectedAdvertiser])
  },
  {
    path: '/reporting',
    name: 'Reporting',
    component: Reporting,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/landing-pages',
    name: 'LandingPages',
    component: LandingPages,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: Campaigns,
    meta: {
      title: 'Outfox AI Campaigns'
    },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/new',
    name: 'NewCampaign',
    component: Campaign,
    props: { model: 'tab-0' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/fundraising',
    name: 'Fundraising',
    component: Fundraising,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/volunteer-outreach',
    name: 'VolunteerOutreach',
    component: VolunteerOutreach,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/voter-outreach',
    name: 'VoterOutreach',
    component: VoterOutreach,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/events',
    name: 'Events',
    component: Events,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns/:id',
    name: 'EditCampaign',
    component: Campaign,
    props: { model: 'tab-0' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/creative',
    name: 'Creative',
    component: Creative,
    props: { model: 'tab-0' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/creative/image',
    name: 'ImageTag',
    component: Creative,
    props: { model: 'tab-0' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/creative/video',
    name: 'VideoTag',
    component: Creative,
    props: { model: 'tab-1' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/creative/copy',
    name: 'Copy',
    component: Creative,
    props: { model: 'tab-2' },
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/audiences',
    name: 'Audiences',
    component: Audiences,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/admin/new-advertiser',
    name: 'NewAdvertiser',
    component: NewAdvertiser,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/admin/setup-accounts',
    name: 'SetupAccounts',
    component: SetupAccounts,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/goals',
    name: 'Goals',
    component: Goals,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/channels',
    name: 'Channels',
    component: Channels,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/setup-checklist',
    name: 'SetupChecklist',
    component: SetupChecklist,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/setup-checklist/:id/:name',
    name: 'SetupChecklistSelectedTask',
    component: SetupChecklist,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/setup-checklist/preview',
    name: 'SetupChecklistPreview',
    component: SetupChecklistPreview,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/preview',
    name: 'Preview',
    component: Preview,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/preview/:id',
    name: 'PreviewShow',
    component: PreviewShow
  },
  {
    path: '/ads/local-events',
    name: 'MobilizeLiveEvents',
    component: MobilizeLiveEvents,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/ads/helpers',
    name: 'MobilizeAdHelpers',
    component: MobilizeAdHelpers,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/events/competitive',
    name: 'MobilizeCompetitiveReport',
    component: MobilizeCompetitiveReport,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/campaigns-new',
    name: 'NewAds',
    component: NewAds,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/events',
    name: 'MobilizeV2EventList',
    component: MobilizeV2EventList,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/events/:id',
    name: 'MobilizeV2EventDetail',
    component: MobilizeV2EventDetail,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/demo/events',
    name: 'MobilizeV2EventDemo',
    component: MobilizeV2EventList,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/image-templates',
    name: 'MobilizeV2ImageTemplateList',
    component: MobilizeV2ImageTemplateList,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/image-templates/new',
    name: 'MobilizeV2CreateImageTemplate',
    component: MobilizeV2CreateImageTemplate,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/image-templates/:id',
    name: 'MobilizeV2ImageTemplateDetail',
    component: MobilizeV2ImageTemplateDetail,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/text-templates',
    name: 'MobilizeV2TextTemplateList',
    component: MobilizeV2TextTemplateList,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/text-templates/new',
    name: 'MobilizeV2CreateTextTemplate',
    component: MobilizeV2CreateTextTemplate,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/text-templates/:id',
    name: 'MobilizeV2TextTemplateDetail',
    component: MobilizeV2TextTemplateDetail,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/campaigns',
    name: 'MobilizeV2CampaignList',
    component: MobilizeV2CampaignList,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/campaigns/new',
    name: 'MobilizeV2CreateCampaign',
    component: MobilizeV2CreateCampaign,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/campaigns/:id',
    name: 'MobilizeV2CampaignDetail',
    component: MobilizeV2CampaignDetail,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/create-templates',
    name: 'MobilizeV2CreateTemplates',
    component: MobilizeV2CreateTemplates,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2/preview-ads',
    name: 'Mobilizev2PreviewAds',
    component: Mobilizev2PreviewAds,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/mobilizev2',
    name: 'MobilizeV2Dashboard',
    component: MobilizeV2Dashboard,
    beforeEnter: multiguard([guards.checkAuth])
  },
  {
    path: '/oops',
    name: 'ErrorsHandling',
    component: ErrorsHandling
  },
  { path: '*', redirect: '/' }
]

export default routes
